import {EventType, EventKind, buildEventCreator, withoutOverrides} from 'services/analytics';

export const converter = withoutOverrides;
export const name = EventKind.UserSavedMoney;
export const createEvent = buildEventCreator<EventType.Detailed, UserSavedMoneyEventPayload>({
  name,
  converter,
});
